import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { FormContext } from './FormContext';
export const FormGroup = /*#__PURE__*/ React.forwardRef(({ className, children, controlId, validationState, componentClass: Component = 'div', ...props }, ref)=>{
    const context = useMemo(()=>({
            controlId,
            validationState
        }), [
        controlId,
        validationState
    ]);
    return /*#__PURE__*/ _jsx(FormContext.Provider, {
        value: context,
        children: /*#__PURE__*/ _jsx(Component, {
            ...props,
            ref: ref,
            className: classNames(className, 'form-group', validationState && `is-${validationState}`),
            children: children
        })
    });
});
FormGroup.displayName = 'FormGroup';
